import {Component, input, InputSignal} from '@angular/core';

@Component({
  selector: 'icon-close-fill',
  imports: [],
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" [attr.width]="size()"
         [attr.height]="size()" viewBox="0 0 24 24">
      <path fill="currentColor" fill-rule="evenodd"
            d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12c0 5.9371 4.81294 10.75 10.75 10.75 5.9371 0
            10.75-4.8129 10.75-10.75 0-5.93706-4.8129-10.75-10.75-10.75ZM9.20711 7.79289c-.39053-.39052-1.02369-.39052-1.41422
             0-.39052.39053-.39052 1.02369 0 1.41422L10.5858 12l-2.79291 2.7929c-.39052.3905-.39052 1.0237
             0 1.4142.39053.3905 1.02369.3905 1.41422 0L12 13.4142l2.7929 2.7929c.3905.3905 1.0237.3905
             1.4142 0 .3905-.3905.3905-1.0237 0-1.4142L13.4142 12l2.7929-2.79289c.3905-.39053.3905-1.02369
             0-1.41422-.3905-.39052-1.0237-.39052-1.4142 0L12 10.5858 9.20711 7.79289Z"
            clip-rule="evenodd" />
    </svg>
  `
})
export class IconCloseFillComponent {
  size: InputSignal<number> = input<number>(24);
}
